import React from 'react'
import Image from '../image'
import Text from '../text';

const EligibilityCard = (props) => {
    const { icon, text, description } = props;
    return (
        <div className="eligibility-card">
            <div className="eligibility-img-icon">
                <Image src={icon} alt={text} />
            </div>
            <Text type="H4" className="eligibility-text" text={text} />
            <Text type="PARAGRAPH" className="eligibility-desc" text={description} />
        </div>
    )
}

export default EligibilityCard